module.exports = __webpack_public_path__ + "static/partner-image2-782a1553ad0abb10427514928ab2c3a1.jpg";